/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Suggestion_StressInputs */

const en_chat_suggestion_stress = /** @type {(inputs: Chat_Suggestion_StressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stress test: 10 random tasks`)
};

const fr_chat_suggestion_stress = /** @type {(inputs: Chat_Suggestion_StressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stress test : 10 tâches aléatoires`)
};

const ms_sg2_chat_suggestion_stress = /** @type {(inputs: Chat_Suggestion_StressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ujian tekanan: 10 tugasan rawak`)
};

/**
* | output |
* | --- |
* | "Stress test: 10 random tasks" |
*
* @param {Chat_Suggestion_StressInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const chat_suggestion_stress = /** @type {((inputs?: Chat_Suggestion_StressInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Suggestion_StressInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_chat_suggestion_stress(inputs)
	if (locale === "fr") return fr_chat_suggestion_stress(inputs)
	return ms_sg2_chat_suggestion_stress(inputs)
});